import { ReactNode } from 'react';

type PropsType = {
  predicate: boolean;
  fallback?: ReactNode;
  children: any;
};

const ConditionalRender = (props: PropsType) => {
  if (props.predicate) {
    return props.children;
  } else if (props.fallback) {
    return props.fallback;
  }
  return null;
};

export default ConditionalRender;
